import {NgModule} from '@angular/core';
import {ModalPlansCardComponent} from './components/modal-plans/modal-plans-card/modal-plans-card.component';
import {ModalPlansStoreModule} from './store/modal-plans-store.module';
import {CommonModule} from '@angular/common';
import {ModalPlansComponent} from './components/modal-plans/modal-plans.component';
import {
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTooltipModule
} from '@angular/material';
import {ModalConfirmUpgradePlanComponent} from './components/modal-plans/modal-plans-card/modal-confirm-upgrade-plan/modal-confirm-upgrade-plan.component';
import {ModalPreviousPlansComponent} from './components/modal-previous-plans/modal-previous-plans.component';
import {RouterModule} from '@angular/router';
import {ModalPlanLimitsExceededComponent} from './components/modal-plan-limits-exceeded/modal-plan-limits-exceeded.component';
import {ModalThanksPageComponent} from './components/modal-thanks-page/modal-thanks-page.component';
import {TranslateModule} from '@ngx-translate/core';
import { ModalPersonalizedPlanComponent } from './components/modal-personalized-plan/modal-personalized-plan.component';
import { ModalContactComponent } from './components/modal-contact/modal-contact.component';


const ENTRY_COMPONENTS = [
    ModalPlansCardComponent,
    ModalConfirmUpgradePlanComponent,
    ModalPreviousPlansComponent,
    ModalPlanLimitsExceededComponent,
    ModalConfirmUpgradePlanComponent,
    ModalPreviousPlansComponent,
    ModalThanksPageComponent,
    ModalPersonalizedPlanComponent,
    ModalContactComponent
];

const COMPONENTS = [
    ModalPlansCardComponent,
    ModalPlansComponent,
    ModalConfirmUpgradePlanComponent,
    ModalPreviousPlansComponent,
    ModalPlanLimitsExceededComponent,
    ModalThanksPageComponent,
    ModalPersonalizedPlanComponent,
    ModalContactComponent
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
    imports: [
        ModalPlansStoreModule,
        CommonModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatIconModule,
        MatDialogModule,
        RouterModule,
        MatTooltipModule,
        MatDividerModule,
        MatButtonModule,
        TranslateModule,
    ],
  exports: [
    ModalPlansCardComponent
  ],
  entryComponents: [
    ENTRY_COMPONENTS
  ],
})
export class ModalPlans { }
